import { useEffect, useState } from "react";
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";

const apiUrl = process.env.REACT_APP_API_URL;

export const useFetchTopDepositors = () => {
  const { getAccessTokenSilently } = useAuth0();
  const [topDepositors, setTopDepositors] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchTopDepositors = async () => {
    try {
      const tk = await getAccessTokenSilently({});

      const response = await axios.get(
        `${apiUrl}/api/v1/transaction/usertransactions`,
        {
          headers: {
            Authorization: `Bearer ${tk}`,
          },
        }
      );

      const transactions = response.data?.response?.data?.transactions || [];
      const totalsByUser: Record<string, number> = {};

      transactions.forEach((tx: any) => {
        const email = tx.email;
        const amount = Number(tx.amount) || 0;

        totalsByUser[email] = (totalsByUser[email] || 0) + amount;
      });

      const result = Object.entries(totalsByUser).map(([email, total]) => ({
        email,
        totalDeposited: total,
      }));

      const top5 = result
        .sort((a, b) => b.totalDeposited - a.totalDeposited)
        .slice(0, 5);

      setTopDepositors(top5);
    } catch (err) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTopDepositors();
  }, []);

  return { topDepositors, loading };
};